import { useState } from 'react';
import type { FC, ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { experimentalStyled } from '@mui/material/styles';
import { ProfileNavbar } from './ProfileNavbar';
import { ProfileSidebar } from './ProfileSidebar';

interface ProfileLayoutProps {
    children?: ReactNode;
    isReseller: boolean;
}

const ProfileLayoutRoot = experimentalStyled('div')(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
}));

const ProfileLayoutWrapper = experimentalStyled('div')(({ theme }) => ({
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: '64px',
    [theme.breakpoints.up('lg')]: {
        paddingLeft: '280px',
    },
}));

const ProfileLayoutContainer = experimentalStyled('div')({
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
});

const ProfileLayoutContent = experimentalStyled('div')({
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto',
    position: 'relative',
    WebkitOverflowScrolling: 'touch',
});

export const ProfileLayout: FC<ProfileLayoutProps> = (props) => {
    const [isSidebarMobileOpen, setIsSidebarMobileOpen] = useState<boolean>(false);
    const { isReseller } = props;

    return (
        <ProfileLayoutRoot>
            <ProfileNavbar onSidebarMobileOpen={(): void => setIsSidebarMobileOpen(true)} isReseller={isReseller} />
            <ProfileSidebar
                onMobileClose={(): void => setIsSidebarMobileOpen(false)}
                openMobile={isSidebarMobileOpen}
                isReseller={isReseller}
            />
            <ProfileLayoutWrapper>
                <ProfileLayoutContainer>
                    <ProfileLayoutContent>
                        <Outlet />
                    </ProfileLayoutContent>
                </ProfileLayoutContainer>
            </ProfileLayoutWrapper>
        </ProfileLayoutRoot>
    );
};
